const RESIZE_OBSERVER_NOISE =
	/ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

let installed = false;

export function installResizeObserverFilter(): void {
	if (installed) {
		return;
	}
	installed = true;

	window.addEventListener('error', (event) => {
		const message = event.message ?? event.error?.message ?? '';
		if (RESIZE_OBSERVER_NOISE.test(message)) {
			event.stopImmediatePropagation();
			event.preventDefault();
		}
	});
}
